import {Style, Fill, Stroke, Text} from 'ol/style.js';
import {transformExtent} from 'ol/proj';
import {GeoJsonLayer} from '../GeoJsonLayer.js';
import Library from '../Library.js';

export class HazardLayer extends GeoJsonLayer {

    constructor( map, settings = {}){
        settings["name"] = 'hazard';
        settings["dynamic_time"] = true;
        settings["api_endpt"] = "HazardJSON.php";
        if( settings.opacity == undefined ) settings['opacity'] = .5;
        if( settings.significance == undefined ) settings['significance'] = "all";
        super( map, settings );
    }

    getUrl( extent, resolution, projection ){
        let extent1 = transformExtent(extent, projection, "EPSG:4326");
        let url = new URL( this.api_path + "/" + this.api_endpt );
        url.searchParams.set( "bbox", extent1.join(","));
        url.searchParams.set( "zoom", this.map.view.getZoom());
        url.searchParams.set( "sig", this.settings['significance']);
        return url.toString();
    }

    getColor( feature ){
        return this.property(feature,'color');
    }

    getHighlightColor(feature){
        return this.property(feature,'color');
    }

    getLabel( feature ){
        return this.property(feature,'phenom');
    }

    getOpacity(feature){
        return this.settings['opacity'];
    }

    getStyle(feature, resolution ){
        let style = new Style({
                "fill": new Fill({
                        "color": Library.parseHexColorToArray(this.getColor(feature), this.settings['opacity'])
                        }),
                "stroke": new Stroke({
                        "color": Library.parseHexColorToArray(this.getColor(feature)),
                        "width": 2
                        }),
                "text": new Text({
                        "font": "12px",
                        "fill": new Fill({
                                "color": Library.parseHexColorToArray(this.getColor(feature))
                                }),
                        "text": this.getLabel(feature),
                        "stroke": new Stroke({"color": "white", "width": 2 })
                        })

                });
        return style;
    }

    getPopupText( feature ){
        let text = this.popupTitle( "HAZARD", this.property(feature,'phenomenon') + " " +
            this.property(feature,'significance'));
        if( this.property(feature,'end') == 0 )
            text += this.popupData( "Ends", "N/A" );
        else
            text += this.popupData( "Ends", Library.formatDate( "%H%M UTC %d %h", this.property(feature,'end')));
        text += this.popupData( "Office", this.property(feature,'office') );
        text += this.popupEnd();
        return text;
    }

    set( key, val ){
        if( key == 'sig' ){
            this.settings['significance'] = val;
            this.refresh();
            return 1;
        }
        if( key in this.settings ){
            if( key == 'opacity' ){
                this.setOpacity( val );
                return 1;
            }
            return super.set( key, val );
        }
        return 0;
    }

    setOpacity( val ){
        this.settings['opacity'] = Number(val);
        this.layer.setOpacity( this.settings['opacity'] );
        return 1;
    }

    updateTime(){
        this.refresh();
    }
}